import 'antd/es/menu/style';
import _Menu from 'antd/es/menu';
import 'antd/es/modal/style';
import _Modal from 'antd/es/modal';
import _regeneratorRuntime from 'babel-runtime/regenerator';
import _Promise from 'babel-runtime/core-js/promise';
import _extends from 'babel-runtime/helpers/extends';
import _asyncToGenerator from 'babel-runtime/helpers/asyncToGenerator';
import _slicedToArray from 'babel-runtime/helpers/slicedToArray';
import 'antd/es/layout/style';
import _Layout from 'antd/es/layout';

var _this = this;

(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};

import React, { useEffect, useState, useRef } from 'react';

import { useClickAway } from 'ahooks';
import { getCompany, getServiceList, getStaffInfo, createService, createCustomerService, getToken, getCompanyId, getProjectId, JOBIDTEST, JOBIDPRO, isJcbUser, getDomain } from 'jcb-token-kit';
import useCustomized from './useCustomized';
import { RollbackOutlined, MenuUnfoldOutlined, ExclamationCircleOutlined } from '@ant-design/icons';
import './QSideMenu.css';

var Sider = _Layout.Sider,
    Content = _Layout.Content;


var MODAL_TYPE = {
  COMPANY_ONLY: 1,
  PERSON_ONLY: 2,
  CAN_OPEN: 3,
  CANT_OPEN: 4
};

var QSideMenu = function QSideMenu(_ref) {
  var children = _ref.children,
      _ref$collapsed = _ref.collapsed,
      collapsed = _ref$collapsed === undefined ? false : _ref$collapsed,
      _ref$dashboardUrl = _ref.dashboardUrl,
      dashboardUrl = _ref$dashboardUrl === undefined ? '' : _ref$dashboardUrl,
      _ref$isProd = _ref.isProd,
      isProd = _ref$isProd === undefined ? false : _ref$isProd,
      _ref$token = _ref.token,
      token = _ref$token === undefined ? '' : _ref$token,
      _ref$isSubTitle = _ref.isSubTitle,
      isSubTitle = _ref$isSubTitle === undefined ? false : _ref$isSubTitle,
      _ref$foldMenu = _ref.foldMenu,
      foldMenu = _ref$foldMenu === undefined ? function () {} : _ref$foldMenu,
      _ref$gotoDashboard = _ref.gotoDashboard,
      gotoDashboard = _ref$gotoDashboard === undefined ? function () {} : _ref$gotoDashboard,
      _ref$changeCollapsed = _ref.changeCollapsed,
      changeCollapsed = _ref$changeCollapsed === undefined ? function () {} : _ref$changeCollapsed,
      _ref$project = _ref.project,
      project = _ref$project === undefined ? '' : _ref$project;

  var companyId_ = process.env.REACT_APP_JCB_ENV === 'dev' ? JOBIDTEST : JOBIDPRO;
  var domain = window.location.protocol + '//' + window.location.host;

  var _useState = useState([]),
      _useState2 = _slicedToArray(_useState, 2),
      menus = _useState2[0],
      setMenus = _useState2[1];

  var _useState3 = useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      loading = _useState4[0],
      setLoading = _useState4[1];

  var _useState5 = useState({}),
      _useState6 = _slicedToArray(_useState5, 2),
      userInfo = _useState6[0],
      setUserInfo = _useState6[1];

  var _useState7 = useState({}),
      _useState8 = _slicedToArray(_useState7, 2),
      company = _useState8[0],
      setCompany = _useState8[1];

  var ref = useRef();
  useClickAway(function () {
    if (foldMenu && !collapsed) {
      foldMenu();
    }
  }, ref);

  useEffect(function () {
    if (collapsed === 1) {
      if (changeCollapsed) {
        setTimeout(function () {
          changeCollapsed(false);
        }, 100);
      }
    }
  }, [collapsed]);
  var getServices = function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var info, data, id, companyid;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return getDomain(project === 'pxb' ? 4 : 2, domain);

            case 2:
              info = _context.sent;
              _context.next = 5;
              return getCompany();

            case 5:
              data = _context.sent;
              id = info.id;
              companyid = data.id === -1 ? 0 : data.id;

              setCompany(_extends({}, data, {
                id: data.id === -1 ? 0 : data.id
              }));
              _Promise.all([getServiceList(id || companyid), getStaffInfo(companyid)]).then(function (datas) {
                setMenus(datas[0]);
                setUserInfo(datas[1]);
                setLoading(false);
              });

            case 10:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }));

    return function getServices() {
      return _ref2.apply(this, arguments);
    };
  }();
  useEffect(function () {
    setLoading(true);
    if (!isJcbUser()) {
      getServices();
    }
  }, []);

  var showConFirm = function showConFirm(type) {
    var serviceName = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
    var serviceType = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
    var redirectUrl = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '';

    var confirmCfg = {};
    confirmCfg.icon = React.createElement(ExclamationCircleOutlined, null);
    if (type === MODAL_TYPE.COMPANY_ONLY) {
      confirmCfg.title = '访问提示';
      confirmCfg.content = '该服务仅限企业内部使用，请切换企业身份或新建企业后使用该服务';
      confirmCfg.okText = '我知道了';
      confirmCfg.cancelText = '取消';
    } else if (type === MODAL_TYPE.PERSON_ONLY) {
      confirmCfg.title = '访问提示';
      confirmCfg.content = '该服务仅限个人使用，请切换个人身份后使用该服务';
      confirmCfg.okText = '我知道了';
      confirmCfg.cancelText = '取消';
    } else if (type === MODAL_TYPE.CAN_OPEN) {
      confirmCfg.title = '开通提示';
      confirmCfg.content = '\u60A8\u53EF\u514D\u8D39\u4F7F\u7528' + serviceName + '\u670D\u52A1\uFF0C\u662F\u5426\u5F00\u901A\uFF1F';
      confirmCfg.okText = '免费开通';
      confirmCfg.cancelText = '暂不开通';
      confirmCfg.onOk = function (close) {
        if (company.id != 0) {
          createService(company.id, serviceType).then(function () {
            close();
            window.location.href = redirectUrl;
          });
        } else {
          createCustomerService(serviceType).then(function () {
            close();
            window.location.href = redirectUrl;
          });
          console.log('开通个人');
        }
      };
    } else if (type === MODAL_TYPE.CANT_OPEN) {
      confirmCfg.title = '访问提示';
      confirmCfg.content = '企业暂未开通此服务，如需使用请联系企业管理员免费开通';
      confirmCfg.okText = '我知道了';
      confirmCfg.cancelText = '取消';
    }

    _Modal.confirm(confirmCfg);
  };
  // serviceType:服务种类1:问卷吧2:检查吧3:督导吧4:培训吧13:申报吧16企业管理工具
  var gotoService = function gotoService(serviceType, serviceName) {
    return function () {
      console.log(serviceType, serviceName);
      if (loading) return;
      var currentMenu = menus.find(function (menu) {
        return menu.serviceType === serviceType;
      });
      if (currentMenu) {
        var currentToken = token || getToken();
        var finalDomain = '\n        ' + currentMenu.serviceDomain + '?token=' + currentToken + '&companyid=' + (getCompanyId() || 0) + '&t=' + new Date().getTime() + '&role=manager&url=' + currentMenu.serviceDomain;
        console.log('------currentMenu----');
        console.log(currentMenu);
        // serviceQualifier 企业使用者 0：无限制 1：企业限定 2：个人限定
        // 企业/用户已经加入的服务
        if (currentMenu.serviceId !== 0) {
          console.log('已开通服务');
          // 企业限定服务（以个人身份登录
          if (currentMenu.serviceQualifier === 1 && company.id === 0) {
            console.log('企业限定，且以个人身份登录');
            return showConFirm(MODAL_TYPE.COMPANY_ONLY);
          }
          // 个人限定服务（以企业身份登录
          if (currentMenu.serviceQualifier === 2 && company.id !== 0) {
            console.log('个人限定，且以企业身份登录');
            return showConFirm(MODAL_TYPE.PERSON_ONLY);
          }
          console.log('----跳转链接----');
          console.log(finalDomain);
          console.log('无限定');
          window.location.href = finalDomain;
        } else {
          console.log('没有开通服务');
          // 企业/用户没有加入服务
          // 企业限定服务
          if (currentMenu.serviceQualifier === 1) {
            console.log('企业限定');
            if (company.id === 0) {
              console.log('个人登录');
              // 个人登录
              showConFirm(MODAL_TYPE.COMPANY_ONLY);
            } else if ([1, 2].indexOf(userInfo.admin) > -1) {
              console.log('超级/企业管理员');
              // 超级/企业管理员
              showConFirm(MODAL_TYPE.CAN_OPEN, serviceName, serviceType, finalDomain);
            } else {
              console.log('不能开通');
              showConFirm(MODAL_TYPE.CANT_OPEN);
            }
          } else {
            console.log('无限制或个人服务');
            // 无限制或个人服务
            showConFirm(MODAL_TYPE.CAN_OPEN, serviceName, serviceType, finalDomain);
          }
        }
      }
    };
  };
  var gotoDygcBackend = function gotoDygcBackend(serviceType) {
    return function () {
      if (loading) return;
      var currentMenu = menus.find(function (menu) {
        return menu.serviceType === serviceType;
      });
      if (currentMenu) {
        if ([1, 2].indexOf(userInfo.admin) > -1) {
          var currentToken = token || getToken();
          window.location.href = '\n        ' + currentMenu.serviceDomain + '/company/staff/list?token=' + currentToken + '&companyid=' + (getCompanyId() || 0);
        } else {
          _Modal.confirm({
            title: '访问提示',
            content: '该服务仅限企业内部使用，请切换企业身份或新建企业后使用该服务',
            okText: '我知道了',
            cancelText: '取消'
          });
        }
      }
    };
  };
  var gotoWorkbench = function gotoWorkbench() {
    if (loading) return;
    var currentMenu = menus.find(function (menu) {
      return menu.serviceType === 0;
    });
    if (currentMenu) {
      gotoDashboard();
      window.location.href = currentMenu.serviceDomain + '/user/workbench/home?companyid=' + (getCompanyId() || 0) + '&token=' + getToken();
    }
  };

  var renderServiceName = function renderServiceName(id, name, isFace) {
    if (!localStorage.getItem('isSpecial') && project !== 'pxb') {
      return name;
    }
    var current = menus.find(function (v) {
      return v.serviceType === id;
    });
    console.log(current.names);
    if (isFace) {
      return current.names[0] === current.names[1] ? name : current.names[1];
    }
    return current.names[0];
  };

  var checkIsLock = function checkIsLock(id, isFace) {
    if (!localStorage.getItem('isSpecial') && project !== 'pxb') {
      return true;
    }
    var current = menus.find(function (v) {
      return v.serviceType === id;
    });
    return isFace ? current.locks[1] : current.locks[0];
  };
  return React.createElement(
    _Layout,
    null,
    React.createElement(
      Sider,
      {
        className: 'sider',
        theme: 'light',
        collapsed: collapsed || collapsed === 1,
        collapsedWidth: 0,
        id: 'siders',
        width: 300
        // onClick={onClickPrevent}
      },
      React.createElement(
        'div',
        { ref: ref },
        React.createElement(
          _Menu,
          { mode: 'inline', className: 'jnm-menu-title' },
          React.createElement(
            _Menu.Item,
            null,
            React.createElement(
              'div',
              { className: 'sider-title' },
              React.createElement(MenuUnfoldOutlined, { onClick: foldMenu }),
              !company.name && React.createElement(
                'span',
                { className: 'small-title' },
                '\u6211\u7684\u670D\u52A1'
              ),
              company.name && company.name.length > 7 && React.createElement(
                'span',
                { className: 'small-title' },
                company.name
              ),
              company.name && company.name.length <= 7 && React.createElement(
                'span',
                null,
                company.name
              )
            )
          )
        ),
        menus.length > 0 && React.createElement(
          _Menu,
          {
            mode: 'inline',
            className: 'jnm-menu',
            style: { paddingLeft: '24px' }
          },
          React.createElement(
            _Menu.Item,
            { key: '1', onClick: gotoService(2, '明察暗访') },
            React.createElement('span', { className: 'icon icon1' }),
            React.createElement(
              'span',
              null,
              renderServiceName(2, '明察暗访')
            )
          ),
          company.id !== companyId_ && checkIsLock(1) && React.createElement(
            _Menu.Item,
            { key: '2', onClick: gotoService(1, '网络调查') },
            React.createElement('span', { className: 'icon icon2' }),
            React.createElement(
              'span',
              null,
              renderServiceName(1, '网络调查')
            )
          ),
          company.id !== companyId_ && checkIsLock(1, true) && React.createElement(
            _Menu.Item,
            { key: '3', onClick: gotoService(1, '面对面访问') },
            React.createElement('span', { className: 'icon icon3' }),
            React.createElement(
              'span',
              null,
              renderServiceName(1, '面对面访问', true)
            )
          ),
          checkIsLock(4) && React.createElement(
            _Menu.Item,
            { key: '4', onClick: gotoService(4, '调研培训') },
            React.createElement('span', { className: 'icon icon4' }),
            React.createElement(
              'span',
              null,
              renderServiceName(4, '调研培训')
            )
          ),
          React.createElement(_Menu.Divider, null),
          React.createElement(
            _Menu.Item,
            { key: '7', onClick: gotoDygcBackend(0) },
            React.createElement('span', { className: 'icon icon7' }),
            React.createElement(
              'span',
              null,
              '\u4F01\u4E1A\u7BA1\u7406\u540E\u53F0'
            )
          )
        ),
        company.id !== companyId_ && React.createElement(
          _Menu,
          { mode: 'inline', className: 'jnm-menu-footer' },
          React.createElement(
            _Menu.Item,
            { key: 'return', onClick: gotoWorkbench },
            React.createElement(
              'div',
              { className: 'jnm-menu-box' },
              React.createElement(RollbackOutlined, null),
              React.createElement(
                'div',
                null,
                '\u8FD4\u56DE\u5DE5\u4F5C\u53F0'
              )
            )
          )
        )
      )
    ),
    React.createElement(
      _Layout,
      { style: { position: 'fixed', top: '0', left: '0', width: '100%' } },
      React.createElement(
        Content,
        null,
        children
      )
    )
  );
};

__signature__(QSideMenu, 'useState{[menus, setMenus]([])}\nuseState{[loading, setLoading](false)}\nuseState{[userInfo, setUserInfo]({})}\nuseState{[company, setCompany]({})}\nuseRef{ref}\nuseClickAway{}\nuseEffect{}\nuseEffect{}', function () {
  return [useClickAway];
});

var _default = QSideMenu;
export default _default;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(Sider, 'Sider', 'src/components/QSideMenu.js');
  reactHotLoader.register(Content, 'Content', 'src/components/QSideMenu.js');
  reactHotLoader.register(MODAL_TYPE, 'MODAL_TYPE', 'src/components/QSideMenu.js');
  reactHotLoader.register(QSideMenu, 'QSideMenu', 'src/components/QSideMenu.js');
  reactHotLoader.register(_default, 'default', 'src/components/QSideMenu.js');
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();